import React from "react";
import { Tab } from "./TabbedSection";
import { Stack } from "@mui/material";
import RegistrationAndAttendance from "../sections/RegistrationAndAttendance";
import CampsitesAndVisitation from "../sections/CampsitesAndVisitation";
import DressCode from "../sections/DressCode";
import WhatToLeave from "../sections/WhatToLeave";
import FridayAndSaturday from "../sections/FridayAndSaturday";
import VolunteerWork from "../sections/VolunteerWork";
import Visitors from "../sections/Visitors";
import Schedule from "../sections/Schedule";

function BackToTop() {
  return <a href="#tab-links">Back to top</a>;
}

function MobileTabbedSection() {
  return (
    <Stack id="tab-links" spacing={1}>
      {Object.values(Tab)
        .filter((tab) => typeof tab === "number")
        .map((tab) => {
          // @ts-ignore
          return <a href={`#${Tab[tab]}`}>{Tab[tab]}</a>;
        })}
      <div id={Tab[Tab.REGISTRATION_AND_ATTENDANCE]}>
        <RegistrationAndAttendance />
        <BackToTop />
      </div>
      <div id={Tab[Tab.CAMPSITES_AND_VISITATION]}>
        <CampsitesAndVisitation />
        <BackToTop />
      </div>
      <div id={Tab[Tab.DRESS_CODE]}>
        <DressCode />
        <BackToTop />
      </div>
      <div id={Tab[Tab.WHAT_TO_LEAVE]}>
        <WhatToLeave />
        <BackToTop />
      </div>
      <div id={Tab[Tab.FRIDAY_AND_SATURDAY]}>
        <FridayAndSaturday />
        <BackToTop />
      </div>
      <div id={Tab[Tab.VOLUNTEER_WORK]}>
        <VolunteerWork />
        <BackToTop />
      </div>
      <div id={Tab[Tab.VISITORS]}>
        <Visitors />
        <BackToTop />
      </div>
      <div id={Tab[Tab.SCHEDULE]}>
        <Schedule />
        <BackToTop />
      </div>
    </Stack>
  );
}

export default MobileTabbedSection;
